import ActionTypes from 'redux/ActionTypes';

const initialState = {
    onAnimation : false,
    spinPrice : 1,
	dice : 0,
    position : 1,
    endPosition : -1,
    modifier: 2,
    lap: 0,
}

const game = (state = initialState, { type, payload }) => {
	switch (type) {
		case ActionTypes.SET_DATA_GAME:
			return { ...state, [payload.key]: payload.data };
		default:
			return state;
	}
};

export default game;